import { topicsData } from '@/mocks/chiguaHomeData';

export default function TopicsSection() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
    accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
    secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            话题热榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            今日吃瓜最热话题标签，点击查看相关今日吃瓜爆料合集
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${colorMap[topic.color]}`}
            >
              <i className="ri-hashtag text-xs"></i>
              {topic.name}
              <span className="text-[11px] opacity-70 ml-1">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}